import React from "react";
import styled from "styled-components";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

const Faq = ({ faq, index, toggleFAQ }) => {
  return (
    <FaqCard
      key={index}
      onClick={() => toggleFAQ(index)}
      style={{ height: faq.open ? "100%" : "70px" }}
      // className={faq.open ? "h100" : "h70"}
    >
      <div className="flexBetween faq-question">
        <h3>{faq.question}</h3>
        <MdOutlineKeyboardArrowDown className="icon" />
      </div>
      <div className={faq.open ? "faqData open" : "none"}>
        <p>{faq.answer}</p>
      </div>
    </FaqCard>
  );
};

export default Faq;

const FaqCard = styled.div`
  padding: 20px 15px;
  background-color: #fff;
  border: 1px solid #3aaa35;
  width: 550px;
  cursor: pointer;
  border-radius: 8px;

  .h100 {
    height: 100%;
  }
  .h70 {
    height: 70px;
  }

  .flexBetween {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon {
      color: #3aaa35;
      font-weight: 600;
      font-size: 25px;
    }
    h3 {
      font-size: 19px;
      font-weight: 500;
    }
  }
  .faqData {
    display: none;
    padding-top: 25px;
    p {
      font-size: 17px;
      font-weight: 500;
    }
  }
  .none {
    display: none;
  }
  .open {
    display: block;
  }
  @media only screen and (max-width: 991px) {
    width: 350px;
  }
`;
